import React, { useEffect, useState } from 'react' 
import {useNavigate, Link} from "react-router-dom";
import dd_logo from "../icons/doordash_logo_with_name_white.svg";
import gh_logo from "../icons/grubhub_logo_with_name_white.svg";
import gr_exterior from '../photos/GR_exterior.png';
import axios from 'axios';

import Navbar from '../components/Navbar/Navbar.jsx';
const OnlineOrder = (props) => {
    const navigate = useNavigate();
    
    return (
        <div className='online-order'>
            {/* <img className='bg-img' src={gr_exterior} alt="" /> */}
            <div className='order-options'>
                <h1>Order Online</h1>
                <h2>Call: <a className='phone-link' href="tel:4848400323">(484) 840-0323</a></h2>
                <span>or</span>
                <div className='order-buttons'>
                    <Link className='pill-button doordash-button' to={'https://www.doordash.com/store/el-gran-rodeo-west-chester-304828/'}><img src={dd_logo} /></Link>
                    <Link className='pill-button grubhub-button' to={'https://www.grubhub.com/restaurant/gran-rodeo-mexican-bar--grill-200-painters-crossing-west-chester/3159623'}><img src={gh_logo}/></Link>
                </div>
            </div>
        </div>
    )
}
export default OnlineOrder;